import Dates from "../components/Dates";

import Edit from "../assets/edit.svg";
import Trash from "../assets/delete.svg";

export default function AdjustmentDetails({
  adjustments,
  setEditAdjustmentTrigger,
  setDeleteAdjustmentTrigger,
}) {
  return (
    <div className="p-2 border text-center project-card">
      <div className="d-flex justify-content-between project-header">
        <h5>Invoice Adjustments</h5>
        <div>
          <img
            src={Edit}
            className="project-edit-image"
            alt="edit"
            onClick={() => setEditAdjustmentTrigger(true)}
          />
          <img
            src={Trash}
            className="project-edit-image"
            alt="trash"
            onClick={() => setDeleteAdjustmentTrigger(true)}
          />
        </div>
      </div>
      <div className="project-card-list">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Item</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
            {adjustments.adjustment_fields.map((a, idx) => (
              <tr key={idx}>
                <td>{a.field_name}</td>
                <td>{a.is_credit ? "Credit" : "Charge"}</td>
                <td>${parseFloat(a.field_value).toLocaleString("en-US")}</td>
                <Dates d={a.date_of_adjustment} />
                <td>{a.adjustment_comments}</td>
              </tr>
            ))}
            <tr>
              <td className="form-totals">Total</td>
              <td></td>
              <td className="form-totals">
                $
                {parseFloat(
                  adjustments.invoice_adjustment.total_adjustment,
                ).toLocaleString("en-US")}
              </td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
